import { lazy, Suspense, useMemo } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

// global scss for globally styles and fonts
import "./_fonts.scss";
import "./_global.scss";

import PublicRoute from "./Components/Routes/PublicRoute.js";
import { WEB_ROUTES } from "./constants.js";
import { baseRoute } from "./Helper";

import { uniqueId } from "lodash";
import CustomLoader from "./Components/CustomComponents/CustomLoader.js";
import ProtectedLayout from "./Components/Layouts/ProtectedLayout.js";
import ProtectedRoute from "./Components/Routes/ProtectedRoute.js";
import VehicleDetailsScreen from "./Pages/VehicleManagement/VehicleDetailsScreen.js";
import VehicleManagementScreen from "./Pages/VehicleManagement/VehicleManagementScreen.js";

// Lazy load the page components
const Account = lazy(() => import("./Pages/Account"));
const Dashboard = lazy(() => import("./Pages/Dashboard"));
const Setting = lazy(() => import("./Pages/Setting"));

const SendNotificationScreen = lazy(() =>
  import("./Pages/SendNotification/SendNotificationScreen.js")
);
const UserManagementScreen = lazy(() =>
  import("./Pages/UserManagement/UserManagementScreen.js")
);
const PageManagementScreen = lazy(() =>
  import("./Pages/PageManagement/PageManagementScreen.js")
);
const TransactionManagementScreen = lazy(() =>
  import("./Pages/TransactionManagement/TransactionManagementScreen.js")
);
const BookingManagementScreen = lazy(() =>
  import("./Pages/BookingManagement/BookingManagementScreen.js")
);

function App() {
  // todo: menu
  const ROUTES = useMemo(() => {
    return [
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.ACCOUNT)}
        element={
          <PublicRoute>
            <Account />
          </PublicRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.DASHBOARD}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Dashboard />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.USER_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <UserManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.VEHICLE_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <VehicleManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.VEHICLE_DETAILS_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <VehicleDetailsScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.PAGE_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <PageManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SEND_NOTIFICATION}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <SendNotificationScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.TRANSACTION_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <TransactionManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.BOOKING_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <BookingManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SETTING}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Setting />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
    ];
  }, []);

  return (
    <Router>
      <Suspense fallback={<CustomLoader />}>
        <Routes>
          {ROUTES.map((item) => item)}
          <Route
            path={baseRoute("*")}
            element={<Navigate to={WEB_ROUTES.ACCOUNT} />}
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
